import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useToast } from "../hooks/use-toast";
import { Toaster } from "../components/ui/toaster";
import { useAdminAuth } from "./AuthContext";
import { Lock, User as UserIcon, Loader2, Wrench } from "lucide-react";

export default function AdminLogin() {
  const { login, user, ready } = useAdminAuth();
  const { toast } = useToast();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (ready && user) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password || submitting) return;
    setSubmitting(true);
    try {
      await login(username, password);
      navigate("/admin");
    } catch (err) {
      toast({
        title: "Login failed",
        description: err?.response?.data?.detail || "Invalid credentials",
        variant: "destructive",
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen hero-gradient flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-xl bg-white shadow-lg mb-3">
            <Wrench size={26} className="text-[#0a4f8a]" />
          </div>
          <h1 className="text-2xl font-extrabold text-white">Cheerings Admin</h1>
          <p className="text-white/80 text-sm">Sign in to manage bookings &amp; enquiries</p>
        </div>
        <form onSubmit={onSubmit} className="bg-white rounded-2xl shadow-2xl p-6 space-y-4">
          <div>
            <Label htmlFor="u" className="text-sm font-semibold text-slate-700 mb-1.5 block">Username</Label>
            <div className="relative">
              <UserIcon size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input id="u" autoFocus value={username} onChange={(e) => setUsername(e.target.value)} placeholder="admin" className="pl-9 h-11" />
            </div>
          </div>
          <div>
            <Label htmlFor="p" className="text-sm font-semibold text-slate-700 mb-1.5 block">Password</Label>
            <div className="relative">
              <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input id="p" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" className="pl-9 h-11" />
            </div>
          </div>
          <Button type="submit" disabled={submitting} className="w-full bg-sky-600 hover:bg-sky-700 text-white font-bold py-5">
            {submitting ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Signing in…</> : "Sign in"}
          </Button>
        </form>
      </div>
      <Toaster />
    </div>
  );
}
